const StatusBox = ({ text, isSelected, onClick, backgroundColor }) => {
  return (
    <div className={`box ${isSelected ? "selected" : ""}`} onClick={onClick}>
      <span className="ring" style={{ backgroundColor }}></span>
      <span>{text}</span>
    </div>
  );
};

export default StatusBox;
